module.exports = __webpack_public_path__ + "src/assets/img/powered_by_stripe.f80d4321.svg";